// import React, { useState, useEffect } from "react";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import "../css/CollectionReport.css";

// const API_URL = "https://payyug.in/api";

// const GoldLoanCollectionReport = () => {
//   const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

//   const [collections, setCollections] = useState([]);
//   const [loading, setLoading] = useState(true);
//       const [company, setCompany] = useState(null);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const [totalPages, setTotalPages] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);

//   const [filters, setFilters] = useState({
//     fromDate: "",
//     toDate: "",
//   });


//    useEffect(() => {
//           const fetchCompany = async () => {
//             try {
//               setLoading(true);
//               const response = await fetch(
//                 `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
//               );
//               const data = await response.json();
      
//               if (response.ok && data) {
//                 // Dynamically construct logo URL
//                 if (data.logo) {
//                   data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, '')}`;
//                 }
//                 setCompany(data);
//               } else {
//                 console.error('Failed to fetch company data');
//               }
//             } catch (err) {
//               console.error('Error fetching company details:', err);
//             } finally {
//               setLoading(false);
//             }
//           };
      
//           if (superAdminId) fetchCompany();
//         }, [ superAdminId]);

//   // ✅ FETCH DATA (SERVER SIDE PAGINATION)
//   useEffect(() => {
//     const fetchCollections = async () => {
//       try {
//         setLoading(true);

//         const res = await axios.get(
//           `${API_URL}/gold-loan/collection-report/all`,
//           {
//             params: {
//               superAdminId,
//               page: currentPage,
//               pageSize: rowsPerPage,
//               fromDate: filters.fromDate,
//               toDate: filters.toDate,
//             },
//           }
//         );

//         if (res.data) {
//           setCollections(res.data.data || []);
//           setTotalPages(res.data.totalPages || 1);
//           setTotalRecords(res.data.totalRecords || 0);
//         }
//       } catch (error) {
//         console.error("Error fetching collection report:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (superAdminId) {
//       fetchCollections();
//     }
//   }, [superAdminId, currentPage, rowsPerPage, filters]);

//   // 🔹 Pagination handlers
//   const handlePrev = () => {
//     if (currentPage > 1) setCurrentPage((prev) => prev - 1);
//   };

//   const handleNext = () => {
//     if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
//   };

//   // 🔹 Filter change
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFilters((prev) => ({
//       ...prev,
//       [name]: value,
//     }));

//     setCurrentPage(1); // reset page on filter change
//   };

//   // 🔹 PDF Export (Current Page Data)
//   const handleDownloadPDF = async() => {
//      const doc = new jsPDF("p", "mm", "a4");
//         const pageWidth = doc.internal.pageSize.width;
//         const pageHeight = doc.internal.pageSize.height;

        
//     // ================= LOGO =================
//     const logoX = 15;
//     const logoY = 12;
//     const logoSize = 25;
//     const logoPadding = 2;

//     // Border color & thickness
//     doc.setDrawColor(0);
//     doc.setLineWidth(0.2);

//     // Calculate center of logo
//     const centerX = logoX + logoSize / 2;
//     const centerY = logoY + logoSize / 2;

//     // Radius = half of logo + padding
//     const radius = logoSize / 2 + logoPadding;

//     // Draw circle
//     doc.circle(centerX, centerY, radius);

//     // Logo image
//     if (company?.logoUrl) {
//       try {
//         const logoResp = await fetch(company.logoUrl);
//         const logoBlob = await logoResp.blob();
//         const reader = new FileReader();
//         await new Promise((resolve) => {
//           reader.onload = () => {
//             doc.addImage(
//               reader.result,
//               "PNG",
//               logoX,
//               logoY,
//               logoSize,
//               logoSize,
//             );
//             resolve();
//           };
//           reader.readAsDataURL(logoBlob);
//         });
//       } catch {
//         // silent fail
//       }
//     }

//     // ================= COMPANY NAME (AUTO WRAP) =================
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(14);

//     const nameX = logoX + logoSize + 5;
//     const nameY = 18;
//     const nameMaxWidth = pageWidth - nameX - 15;

//     const companyNameText = doc.splitTextToSize(
//       (company?.name || "COMPANY NAME").toUpperCase(),
//       nameMaxWidth,
//     );

//     doc.text(companyNameText, nameX, nameY);

//     // Calculate Y after company name
//     let currentY = nameY + companyNameText.length * 6;

//     // ================= COMPANY DETAILS =================
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(11);

//     const detailX = nameX;
//     const detailMaxWidth = nameMaxWidth;

//     // Address
//     const addressText = doc.splitTextToSize(
//       company?.address || "Company Address",
//       detailMaxWidth,
//     );
//     doc.text(addressText, detailX, currentY);
//     currentY += addressText.length * 5;

//     // Email
//     const emailText = doc.splitTextToSize(
//       `Email: ${company?.email || "-"}`,
//       detailMaxWidth,
//     );
//     doc.text(emailText, detailX, currentY);
//     currentY += emailText.length * 5;

//     // Phone
//     const phoneText = doc.splitTextToSize(
//       `Phone: ${company?.contact || "-"}`,
//       detailMaxWidth,
//     );
//     doc.text(phoneText, detailX, currentY);
//     currentY += phoneText.length * 5;

//     // Divider
//     doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);

//     // ================= REPORT TITLE =================
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(13);
//     doc.text("Gold Loan Collection Report", pageWidth / 2, currentY + 14, {
//       align: "center",
//     });

//     const tableColumn = [
//       "#",
//       "Payment Amount",
//       "Payment Mode",
//       // "EMI Number",
//       // "EMI Amount",
//       // "Principal",
//       // "Interest",
//       // "Outstanding",
//       // "Due Date",
//       "Payment Date",
//       // "Status",
//     ];

//     const tableRows = collections.map((c, index) => [
//       (currentPage - 1) * rowsPerPage + index + 1,
//       `Rs. ${c.paymentAmount.toLocaleString("en-GB")}`,
//       c.paymentMode,
//       // c.emiNumber,
//       // `${c.emiAmount?.toLocaleString()}`,
//       // `${c.principalComponent?.toLocaleString()}`,
//       // `${c.interestComponent?.toLocaleString()}`,
//       // `${c.outstanding?.toLocaleString()}`,
//       // new Date(c.dueDate).toLocaleDateString("en-IN"),
//       c.paymentDate
//         ? new Date(c.paymentDate).toLocaleDateString("en-GB")
//         : "-",
//       // c.status?.toUpperCase(),
//     ]);

//     autoTable(doc, {
//         startY: currentY + 20,
//         head: [tableColumn],
//         body: tableRows,
  
//         theme: "grid",
//         styles: {
//           fontSize: 7,
//           cellPadding: 3,
//           halign: "center",
//         },
//         headStyles: {
//           fontStyle: "bold",
//           fontSize: 7,
//         },
//         alternateRowStyles: {
//           fillColor: [245, 245, 245],
//         },
  
//         didDrawPage: function () {
//           const pageWidth = doc.internal.pageSize.width;
//           const pageHeight = doc.internal.pageSize.height;
  
//           doc.setDrawColor(0);
//           doc.setLineWidth(0.2);
  
//           // Page border on EVERY page
//           doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
//         },
//       });

//       // ================= FOOTER =================
//     const pageCount = doc.internal.getNumberOfPages();
//     for (let i = 1; i <= pageCount; i++) {
//       doc.setPage(i);
//       doc.setFontSize(8);
//       doc.setTextColor(100);
//       doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
//       doc.text("Generated by Collection System", 14, pageHeight - 10);
//     }

//     doc.save("Gold_Loan_Collection_Report.pdf");
//   };

//   // 🔹 Excel Export (Current Page Data)
//   const handleDownloadExcel = () => {
//     const excelData = collections.map((c, index) => ({
//       "#": (currentPage - 1) * rowsPerPage + index + 1,
//       "Payment Amount": c.paymentAmount,
//       "Payment Mode": c.paymentMode,
//       // "Loan Number": c.loanNumber,
//       // "EMI Number": c.emiNumber,
//       // "EMI Amount": c.emiAmount,
//       // "Principal": c.principalComponent,
//       // "Interest": c.interestComponent,
//       // "Outstanding": c.outstanding,
//       // "Due Date": new Date(c.dueDate).toLocaleDateString("en-IN"),
//       "Payment Date": c.paymentDate
//         ? new Date(c.paymentDate).toLocaleDateString("en-GB")
//         : "-",
//       // Status: c.status,
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(excelData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Gold Loan Collection Report");

//     const excelBuffer = XLSX.write(workbook, {
//       bookType: "xlsx",
//       type: "array",
//     });

//     const blob = new Blob([excelBuffer], {
//       type:
//         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
//     });

//     saveAs(blob, "Collection_Report.xlsx");
//   };

//   return (
//     <div className="CollectionReport-wrapper">
//       <h1 className="CollectionReport-title">
//         Gold Loan Collection Report
//       </h1>

//       <div className="CollectionReport-grid">
//         <div className="CollectionReport-formGroup">
//           <label>From Date</label>
//           <input type="date" name="fromDate" onChange={handleChange} />
//         </div>
//         <div className="CollectionReport-formGroup">
//           <label>To Date</label>
//           <input type="date" name="toDate" onChange={handleChange} />
//         </div>
//       </div>

//       <div className="CollectionReport-controls">
//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//           </select>{" "}
//           entries
//         </label>

//         <div className="CollectionReport-actions">
//           <button className="filter-btn excel-btn" onClick={handleDownloadExcel}>
//             📊 Download Excel
//           </button>
//           <button className="filter-btn" onClick={handleDownloadPDF}>
//             📄 Download PDF
//           </button>
//         </div>
//       </div>

//       <div className="CollectionReport-table-container">
//         {loading ? (
//           <p className="CollectionReport-loading">⏳ Loading data...</p>
//         ) : (
//           <table className="CollectionReport-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Payment Amount</th>
//                 <th>Payment Mode</th>
//                 <th>Payment Date</th>
//                 {/* <th>Outstanding</th>
//                 <th>Due Date</th>
//                 <th>Payment Date</th>
//                 <th>Status</th> */}
//               </tr>
//             </thead>
//             <tbody>
//               {collections.length === 0 ? (
//                 <tr>
//                   <td colSpan="4" className="CollectionReport-empty">
//                     ✅ No records found
//                   </td>
//                 </tr>
//               ) : (
//                 collections.map((c, idx) => (
//                   <tr key={c.id}>
//                     <td>
//                       {(currentPage - 1) * rowsPerPage + idx + 1}
//                     </td>
//                     <td>{`₹${c.paymentAmount?.toLocaleString()}`|| "N/A"}</td>
//                      <td>{c.paymentMode || "N/A"}</td>
//                     {/* <td>{c.customerName || "N/A"}</td>
//                     <td>{c.loanNumber || "N/A"}</td>
//                     <td>{c.emiNumber || "N/A"}</td> */}
//                     {/* <td>₹{c.principalComponent?.toLocaleString() || "0"}</td>
//                     <td>₹{c.interestComponent?.toLocaleString() || "0"}</td>
//                     <td>₹{c.outstanding?.toLocaleString() || "0"}</td> */}
//                     {/* <td>
//                       {new Date(c.dueDate).toLocaleDateString("en-GB")}
//                     </td> */}
//                     <td>
//                       {c.paymentDate
//                         ? new Date(c.paymentDate).toLocaleDateString("en-GB")
//                         : "N/A"}
//                     </td>
//                     {/* <td>
//                       <span
//                         className={`CollectionReport-status ${
//                           c.status === "pending" ? "pending" : "paid"
//                         }`}
//                       >
//                         {c.status}
//                       </span>
//                     </td> */}
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         )}
//       </div>

//       {!loading && (
//         <div className="CollectionReport-pagination">
//           <button
//             className="pagination-btn"
//             onClick={handlePrev}
//             disabled={currentPage === 1}
//           >
//             ⬅ Prev
//           </button>

//           <span className="pagination-info">
//             Page {currentPage} of {totalPages}
//           </span>

//           <button
//             className="pagination-btn"
//             onClick={handleNext}
//             disabled={currentPage === totalPages}
//           >
//             Next ➡
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default GoldLoanCollectionReport;




import React, { useState, useEffect, useCallback } from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import "./GoldLoanCollectionReport.css";
import { toast } from "react-toastify";

const API_URL = "https://payyug.in/api";

const GoldLoanCollectionReport = () => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [company, setCompany] = useState(null);
  const [branchs, setBranchs] = useState([]);

  const [filters, setFilters] = useState({
    branchId: "",
    fromDate: "",
    toDate: "",
  });

  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Fetch Company Details
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(`${API_URL}/get-company?superAdminId=${superAdminId}`);
        const data = await response.json();
        if (response.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) { console.error(err); }
    };
    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  // Fetch Branches
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: { SuperAdminId: superAdminId, limit: "all" },
        });
        setBranchs(res?.data.branches || []);
      } catch (err) { console.error(err); }
    };
    if (superAdminId) fetchBranch();
  }, [superAdminId]);

  // Fetch Collections - Updated for your API response structure
  const fetchCollections = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}/gold-loan/manual-collections/pay`, {
        params: {
          superAdminId,
          branchId: filters.branchId,
          fromDate: filters.fromDate,
          toDate: filters.toDate,
          page: currentPage,
          limit: rowsPerPage,
        },
      });

      // Based on your response: { success: true, totalPages: X, data: [...] }
      if (res.data && res.data.success) {
        setCollections(res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to fetch records");
    } finally {
      setLoading(false);
    }
  }, [superAdminId, filters, currentPage, rowsPerPage]);

  useEffect(() => {
    fetchCollections();
  }, [fetchCollections]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1); // Filter change reset to page 1
    fetchCollections();
    toast.success("Filtered successfully!");
  };

  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

  // Professional PDF Export
  const handleDownloadPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.width;
    
    // Logo & Header
    if (company?.logoUrl) {
      try {
        const res = await fetch(company.logoUrl);
        const blob = await res.blob();
        const base64 = await new Promise((r) => {
          const reader = new FileReader();
          reader.onloadend = () => r(reader.result);
          reader.readAsDataURL(blob);
        });
        doc.addImage(base64, "PNG", 15, 12, 22, 22);
        doc.circle(26, 23, 13);
      } catch (e) { console.warn(e); }
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text((company?.name || "GOLD LOAN CO.").toUpperCase(), 42, 18);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(company?.address || "Address Detail", 42, 23);
    doc.text(`Email: ${company?.email || "-"} | Phone: ${company?.contact || "-"}`, 42, 28);
    
    doc.line(10, 38, pageWidth - 10, 38);
    doc.setFontSize(11);
    doc.text("COLLECTION TRANSACTION REPORT", pageWidth / 2, 46, { align: "center" });

    const tableColumn = ["#", "Br. ID", "Principal", "Interest", "Total", "Type", "Mode", "Date"];
    const tableRows = collections.map((c, i) => [
      (currentPage - 1) * rowsPerPage + i + 1,
      c.branchId || "-",
      `Rs.${c.principalAmount?.toLocaleString()}`,
      `Rs.${c.interestAmount?.toLocaleString()}`,
      `Rs.${c.totalAmount?.toLocaleString()}`,
      c.collectionType || "-",
      c.paymentMode || "-",
      c.collectionDate ? new Date(c.collectionDate).toLocaleDateString("en-GB") : "-",
    ]);

    autoTable(doc, {
      startY: 52,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      styles: { fontSize: 7, halign: "center" },
      headStyles: { fillColor: [40, 40, 40] },
      didDrawPage: (data) => {
        doc.rect(8, 8, pageWidth - 16, doc.internal.pageSize.height - 16);
      }
    });

    doc.save(`Collection_Report_Page_${currentPage}.pdf`);
  };

  return (
    <div className="collection-report-container">
      <h1 className="collection-report-title">📋 Collection Report</h1>

      {/* FILTER SECTION (Original Design) */}
      <section className="pending-disbursal-filter-section">
        <h2 className="pending-disbursal-title">Collection Report Filter</h2>
        <form className="pending-disbursal-form" onSubmit={handleSubmit}>
          <div className="pending-disbursal-grid">
            <div className="pending-disbursal-form-group">
              <label>Branch</label>
              <select name="branchId" value={filters.branchId} onChange={handleChange}>
                <option value="">All Branches</option>
                {branchs.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
              </select>
            </div>
            <div className="pending-disbursal-form-group">
              <label>From Date</label>
              <input type="date" name="fromDate" value={filters.fromDate} onChange={handleChange} />
            </div>
            <div className="pending-disbursal-form-group">
              <label>To Date</label>
              <input type="date" name="toDate" value={filters.toDate} onChange={handleChange} />
            </div>
          </div>
          <div className="filterbtnpdt">
            <button type="submit" className="pending-disbursal-submit-btn">Apply Filter</button>
          </div>
        </form>
      </section>

      {/* CONTROLS */}
      <div className="collection-report-controls">
        <label>
          Show{" "}
          <select value={rowsPerPage} onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}>
            {[10, 25, 50, 100].map(v => <option key={v} value={v}>{v}</option>)}
          </select> entries
        </label>
        <button className="collection-report-filter-btn" onClick={handleDownloadPDF}>📄 Export PDF</button>
      </div>

      {/* TABLE */}
      <div className="collection-report-table-container">
        {loading ? (
          <p className="collection-report-loading">⏳ Loading...</p>
        ) : (
          <table className="collection-report-table">
            <thead>
              <tr>
                <th>#</th>
                {/* <th>Branch ID</th> */}
                <th>Principal</th>
                <th>Interest</th>
                <th>Total</th>
                <th>Type</th>
                <th>Payment Mode</th>
                <th>Date</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {collections.length === 0 ? (
                <tr><td colSpan="9" className="collection-report-empty">No records found</td></tr>
              ) : (
                collections.map((c, idx) => (
                  <tr key={idx}>
                    <td>{(currentPage - 1) * rowsPerPage + idx + 1}</td>
                    {/* <td>{c.branchId || "N/A"}</td> */}
                    <td>{c.principalAmount?`₹${c.principalAmount?.toLocaleString()}`:"N/A"}</td>
                    <td>{c.interestAmount?`₹${c.interestAmount?.toLocaleString()}`:"N/A"}</td>
                    <td>{c.totalAmount?`₹${c.totalAmount?.toLocaleString()}`:"N/A"}</td>
                    <td>{c.collectionType}</td>
                    <td>{c.paymentMode}</td>
                    <td>{c.collectionDate ? new Date(c.collectionDate).toLocaleDateString("en-IN") : "-"}</td>
                    <td>{c.remarks || "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* PAGINATION (Logic updated to use totalPages from API) */}
      {!loading && (
        <div className="collection-report-pagination">
          <button className="collection-report-pagination-btn" onClick={handlePrev} disabled={currentPage === 1}>⬅ Prev</button>
          <span className="collection-report-pagination-info">Page {currentPage} of {totalPages}</span>
          <button className="collection-report-pagination-btn" onClick={handleNext} disabled={currentPage === totalPages}>Next ➡</button>
        </div>
      )}
    </div>
  );
};

export default GoldLoanCollectionReport;